import { rescueModalSchema } from "@redotech/redo-model/checkouts/predictive-conversion-settings";
import * as z from "zod/v4";

export const updateCheckoutProbabilityRescueModalSettings = {
  name: "updateCheckoutProbabilityRescueModalSettings" as const,
  input: z.object({ settings: rescueModalSchema }),
  output: z.null(),
};
